

import 'babel-polyfill'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import App from './App'
import router from './router'
import i18n from './locale/i18n'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import store from './store'
import axios from './axios'
import api from './server'
import vueSmoothScroll from 'vue-smoothscroll'
import VueScroller from 'vue-scroller'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import './util/vconsole'

Vue.config.productionTip = false

Vue.use(VueClipboard)
Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(vueSmoothScroll)
Vue.use(VueScroller)

Vue.use(preview, {
fullscreenEl:false,

zoomEl: false,
maxSpreadZoom: 1,
getDoubleTapZoom: function(isMouseClick, item) {
return item.initialZoomLevel;
},
pinchToClose: false
})

router.afterEach((to,from,next) => {
window.scrollTo(0,0);
});

Vue.prototype.$http = axios;
/* eslint-disable no-new */
new Vue({
el: '#app',
i18n,
store,
router,
components: {App},
template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js